import TagManager from 'react-gtm-module';
import ReactGA from "react-ga4";
import TiktokPixel from 'tiktok-pixel';
import FacebookPixel from 'react-facebook-pixel';

export class Analytics {
  constructor({
    googleTagManagerId,
    googleAnalytics4MeasurmentId,
    googleAdwordsConversionId,
    googleAdwordsConversionLabel,
    tikTokPixelId,
    facebookPixelId,
  }) {
    this.googleTagManagerId = googleTagManagerId;
    this.googleAnalytics4MeasurmentId = googleAnalytics4MeasurmentId;
    this.googleAdwordsConversionId = googleAdwordsConversionId;
    this.googleAdwordsConversionLabel = googleAdwordsConversionLabel;
    this.tikTokPixelId = tikTokPixelId;
    this.facebookPixelId = facebookPixelId;
  }

  init() {
    if (this.googleTagManagerId) {
      TagManager.initialize({
        gtmId: this.googleTagManagerId,
      });
    };

    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.initialize([
        {
          trackingId: this.googleAnalytics4MeasurmentId,
        },
        {
          trackingId: "G-PMBNH8NYBV",
        },
      ]);
    };

    if (this.googleAdwordsConversionId && this.googleAdwordsConversionLabel) {
      window.gtag('event', 'conversion', {
        'send_to': `AW-${this.googleAdwordsConversionId}/${this.googleAdwordsConversionLabel}`,
        /* 'value': 1.0,                            // Optional: Conversion Value
        'currency': 'USD',                       // Optional: Currency
        'transaction_id': ''                     // Optional: Unique Transaction ID */
      });
    }

    if (this.tikTokPixelId) {
      TiktokPixel.init(this.tikTokPixelId);
    };

    if (this.facebookPixelId) {
      FacebookPixel.init(this.facebookPixelId);
    }
  }

  pageView(transactionId, slug) {
    if (this.googleAnalytics4MeasurmentId) {
      if (!transactionId) {
        ReactGA.send({
          hitType: "pageview",
          page: window.location.pathname,
          title: `View slug page - ${slug}`
        });
      } else {
        ReactGA.send({
          hitType: "pageview",
          page: window.location.pathname,
          title: `View Offer page`
        });
      };
    };

    if (this.tikTokPixelId) {
      TiktokPixel.pageView();
    };

    if (this.facebookPixelId) {
      FacebookPixel.pageView();
    }
  };

  goToFormPage() {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Next_btn_click",
        action: "Go_to_Form_page",
        label: 'View_Form_page',
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('ClickButton', {
        content_category: 'Next_btn_click',
        content_name: 'View_Form_page',
      });
    };

    if (this.facebookPixelId) {
      FacebookPixel.track('ViewContent', {
        content_type: 'Next_btn_click',
        content_name: 'View_Form_page',
      });
    };
  }

  goToPaymentPage() {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Next_btn_click",
        action: "Go_to_Payment_page",
        label: 'View_Payment_page',
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('ClickButton', {
        content_category: 'Next_btn_click',
        content_name: 'View_Payment_page',
      });
    };

    if (this.facebookPixelId) {
      FacebookPixel.track('ViewContent', {
        content_type: 'Next_btn_click',
        content_name: 'View_Payment_page',
      });
    };
  }

  clickPaymentBtn() {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Pay_btn_click",
        action: "Go_to_Payment_provider",
        label: 'Payment_provider',
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('ClickButton', {
        content_category: 'Pay_btn_click',
        content_name: 'Go_to_Payment_provider',
      });
    };
  }

  getSuccessTransaction(transaction) {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Transaction_result",
        action: "Transaction_success",
        label: `Pay with ${transaction.paymentMethodId}`,
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('CompletePayment', {
        content_category: 'Transaction_result',
        content_name: 'Transaction_success',
      });
    };

    if (this.facebookPixelId) {
      FacebookPixel.track('Purchase', {
        content_type: 'Transaction_result',
        content_name: 'Transaction_success',
      });
    };
  }

  getErrorTransaction(transaction) {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Transaction_result",
        action: "Transaction_error",
        label: `Pay with ${transaction.paymentMethodId}`,
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('CompletePayment', {
        content_category: 'Transaction_result',
        content_name: 'Transaction_error',
      });
    };

    if (this.facebookPixelId) {
      FacebookPixel.track('Purchase', {
        content_type: 'Transaction_result',
        content_name: 'Transaction_error',
      });
    };
  }

  getRefundTransaction(transaction) {
    if (this.googleAnalytics4MeasurmentId) {
      ReactGA.event({
        category: "Transaction_result",
        action: "Transaction_refund",
        label: `Pay with ${transaction.paymentMethodId}`,
      });
    };

    if (this.tikTokPixelId) {
      TiktokPixel.track('CompletePayment', {
        content_category: 'Transaction_result',
        content_name: 'Transaction_refund',
      });
    };

    if (this.facebookPixelId) {
      FacebookPixel.track('Purchase', {
        content_type: 'Transaction_result',
        content_name: 'Transaction_refund',
      });
    };
  }
}
